import classNames from 'classnames'
import React from 'react'
import injectStyles from 'react-jss'
import { styles } from './styles'
import { CHAT_TYPE } from '../../Containers/ChatV2/options'

const TabsV2 = props => {
  const {
    classes,
    selectedValue,
    onPress,
    options,
    getChatOptions,
    unreadStatuses,
    setNotificationConversation,
    setConversationId,
  } = props
  return (
    <div key={unreadStatuses} className={classes.container}>
      {options.map(item => {
        const canShowCounter =
          !unreadStatuses || item.value == CHAT_TYPE.GROUP_CHAT
            ? false
            : item.value == CHAT_TYPE.SINGLE_CHAT
            ? unreadStatuses.hasUnreadChats
            : unreadStatuses.hasUnreadReport

        return (
          <div
            className={classNames({
              [classes.item]: true,
              [classes.tab]: true,
              [classes.tabActive]: selectedValue == item.value,
            })}
            cypress_id={'chatTabs'}
          >
            <div
              onClick={() => {
                setConversationId(null)
                setNotificationConversation(null)
                onPress(item.value)
                getChatOptions()
              }}
            >
              {item.tab}
            </div>
            {canShowCounter && (
              <div
                className={classNames({
                  [classes.barge]: true,
                  [classes.bargeActive]: selectedValue == item.value,
                })}
                cypress_id={'badgeActive'}
              />
            )}
          </div>
        )
      })}
    </div>
  )
}

export default injectStyles(styles)(TabsV2)
